/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';


export const SvgDocument = ({ size }) => {
    return (<Svg
        viewBox="0 0 80 74"
        height={size}
        width={size}
    >
    <G id="Layer_2" data-name="Layer 2" />
    <G id="Layer_1-2" data-name="Layer 1" />
    <Path class="cls-1" fill = "#fff" d="M64,0a2.24,2.24,0,0,1,2,2V20H78a2.21,2.21,0,0,1,2,2V65a9,9,0,0,1-9,9H9a9,9,0,0,1-9-9V2A2.08,2.08,0,0,1,2,0ZM62,4H4V65a5,5,0,0,0,5,5H63.75A8.7,8.7,0,0,1,62,65Zm-8,6a2.2,2.2,0,0,1,2,2V26a2.08,2.08,0,0,1-2,2H34a2.08,2.08,0,0,1-2-2V12a2.08,2.08,0,0,1,2-2ZM24,12a2,2,0,0,1,0,4H12a2,2,0,0,1,0-4Zm28,2H36V24H52ZM24,22a2,2,0,0,1,0,4H12a2,2,0,0,1,0-4Zm52,2H66V65a5,5,0,0,0,10,0ZM54,34a2,2,0,0,1,0,4H12a2,2,0,0,1,0-4Zm0,11a2,2,0,0,1,0,4H12a2,2,0,0,1,0-4Zm0,11a2,2,0,0,1,0,4H12a2,2,0,0,1,0-4Z"/>

    </Svg>)
}

